import { AnalyticsService } from "mis-crystal-design-system/analytics";
import { Component, EventEmitter, OnDestroy, OnInit, Output } from "@angular/core";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { DeleteConfirmationComponent } from "../../forms/delete-confirmation/delete-confirmation.component";
import { BookingComponent } from "../../modals/booking/booking.component";
import { CheckinConfirmComponent } from "../../modals/checkin-confirm/checkin-confirm.component";
import { UpcomingBookingsComponent } from "../../modals/upcoming-bookings/upcoming-bookings.component";
import { WIDGET_LIST } from "../../../constants/quick-actions.constants";
import { NsWISConfigurations } from "../../../models/configurations.model";
import { NsEmpWebExpData } from "../../../models/emp-web-exp.model";
import { ApiService } from "../../../services/api.service";
import { BookingDataService } from "../../../services/booking-data.service";
import { ConfigurationService } from "../../../services/configuration.service";
import { HomeDataService } from "../../../services/home-data.service";
import { LoaderService } from "../../../services/loader.service";
import { DrawerService } from "mis-design-system/drawer";
import { ToastService } from "mis-crystal-design-system/toast";
import { EmpUserService } from "../../../services/emp-user.service";
import { parseZone, Moment } from "moment";
import { Subject, Observable, combineLatest, throwError } from "rxjs";
import { takeUntil, catchError, switchMap, map, tap } from "rxjs/operators";
import { validateHeroBooking } from "../../../functions/booking-utils.functions";
import { filterOut } from "../../../functions/custom-operators.functions";
import { WidgetService } from "../../../services/widget.service";
import { CONSTANTS_ASSETS_EMP_WEB_EXP } from "../../../constants/assets.constants";
import { FabItems } from "mis-design-system/fab";
import MISC from "../../../constants/misc.constants";
import { ModalService } from "mis-design-system/mis-modal";
import { BreakpointObserver } from "@angular/cdk/layout";
import { WidgetGroup } from "mis-crystal-design-system/widgets";
import { AsyncWidget } from "mis-crystal-design-system/widgets";
import { minLength, maxLength } from "../../../functions/booking-utils.functions";
import { SyncWidget } from "mis-crystal-design-system/widgets";
import { MealFeedbackModalComponent } from "../../modals/meal-feedback-modal/meal-feedback-modal.component";

declare let gtag: Function;

const LayoutSettings = {
  columns: 2,
  breakpoints: {
    1250: {
      columns: 1
    }
  }
};

@Component({
  selector: "mis-employee-web-exp-body",
  templateUrl: "./body.component.html",
  styleUrls: ["./body.component.scss"]
})
export class BodyComponent implements OnInit, OnDestroy {
  timezone: string;
  Assets = CONSTANTS_ASSETS_EMP_WEB_EXP;
  fabItems: FabItems = [
    {
      label: "Work from Office",
      id: "WFO",
      icon: this.Assets.ICONS.IC_WFO,
      backgroundColor: "#0087B2",
      click: () => {
        this.handleQuickActions("OFFICE");
      }
    },
    {
      label: "Work from Home",
      id: "WFH",
      icon: this.Assets.ICONS.IC_WFH,
      backgroundColor: "#ED711C",
      click: () => {
        this.handleQuickActions("WFH");
      }
    }
  ];
  endObs = new Subject<void>();
  employeeData: NsEmpWebExpData.IEmployee;
  createAllowed: boolean;
  widgets = [];
  configurations: NsWISConfigurations.IConfigurations;
  cancelStream = this.bookingSvc.cancelBookings.pipe(takeUntil(this.endObs));

  teamCalendarUrl: string = "";
  displayTeamCalendar: boolean = false;
  upcomingBookingList: NsEmpWebExpData.IList[] = [];
  meetingBookingList: NsEmpWebExpData.IList[] = [];
  bookingSource: Observable<NsEmpWebExpData.IList[]>;
  meetingSource: Observable<NsEmpWebExpData.IList[]>;
  heroSource: Observable<NsEmpWebExpData.IBookingDetailDTOS>;
  mealSource: Observable<NsEmpWebExpData.IList[]>;
  @Output() showTeamCalendar = new EventEmitter(false);
  columnGroups: Observable<Array<Array<NsEmpWebExpData.IWidget>>>;
  isRedirected: boolean = false;
  bookingRequestStatusList: Set<string> = new Set(["CONFIRMED", "PENDING", "SIGNED_IN", "SIGNED_OUT"]);
  allWidgets: WidgetGroup;

  bookingId: string;
  userEmail: string;
  heroBooking;

  constructor(
    private homeData: HomeDataService,
    private user: EmpUserService,
    private toast: ToastService,
    private apiService: ApiService,
    public bookingSvc: BookingDataService,
    private drawerSvc: DrawerService,
    private modalSvc: ModalService,
    private loader: LoaderService,
    public configSvc: ConfigurationService,
    private router: Router,
    private route: ActivatedRoute,
    private widgetSvc: WidgetService,
    private breakpointObs: BreakpointObserver,
    private analytics: AnalyticsService
  ) {}

  ngOnInit(): void {
    // this.modalSvc.show(IpConsentComponent, null);
    this.widgetSvc.refresh.pipe(takeUntil(this.endObs)).subscribe(group => {
      if (!group) {
        return this.allWidgets?.reset();
      } else if (group[0] === "HERO") {
        return this.allWidgets.get("heroSource").reset();
      } else if (group[0] === "UPCOMING") {
        this.getBookings(group[1]);
        // this.updateWidgets();
        return;
      } else if (group[0] === "MEETINGS") {
        return this.allWidgets.get("meetingSource").reset();
      } else if (group[0] === "MEALS")  {
        return this.allWidgets.get("mealSource").reset();
      } else if (group[0] === "BOOKINGS") {
        this.allWidgets.get("heroSource").reset();
        return this.allWidgets.get("bookingSource").reset();
      }
    });
    this.homeData.actionStream.pipe(takeUntil(this.endObs)).subscribe(res => {
      this.handleQuickActions(res);
    });
    this.getEmpDetails();
  }

  ngOnDestroy(): void {
    this.loader.hide();
    this.endObs.next();
    this.endObs.complete();
  }

  handlerCreateCallback = (id: "WFH" | "OFFICE") => {
    const configs = this.bookingSvc.setFormForCreate(this.configurations, this.employeeData, id);
    const ref = this.drawerSvc.show(BookingComponent, configs, { ...(this.configSvc.isMobile && { width: "100%" }) });
    ref.afterClosed.subscribe(res => {
      if (res === "DONE") {
        this.widgetSvc.refreshWidgets("BOOKINGS");
      }
    });
    if (id == "WFH") {
      this.analytics.send("emp_web_wfh_form", "emp_web", "click", "");
    } else {
      this.analytics.send("emp_web_wfo_form", "emp_web", "click", "");
    }
  };

  handleQuickActions(id: "OFFICE" | "WFH"): void {
    if (id === "OFFICE" || id === "WFH") {
      this.homeData.quickActionEvent(id, res => {
        if (res) this.handlerCreateCallback(id);
      });
    }
  }

  private getEmpDetails(): void {
    this.loader.show();
    combineLatest([
      this.apiService.getEmpTimezone().pipe(
        catchError(err => {
          this.loader.hide();
          this.toast.displayMsg(this.toast.messageBuilder.error.simple);
          return throwError(`Failed to load timezone. ${JSON.stringify(err)}`);
        })
      ),
      this.configSvc?.configurations?.pipe(
        catchError(err => {
          this.loader.hide();
          this.toast.displayMsg(this.toast.messageBuilder.error.simple);
          return throwError(`Failed to load Configurations. ${JSON.stringify(err)}`);
        })
      ),
      this.homeData.employeeInfo
    ])
      .pipe(takeUntil(this.endObs))
      .subscribe(
        ([res, configs, employeeData]) => {
          this.loader.hide();
          this.timezone = res;
          this.bookingSvc.timezone = this.timezone;
          this.configurations = configs;
          this.employeeData = employeeData;
          const found = this.configurations?.BUSettings?.features.find(x => x.id === "booking");
          this.createAllowed = found?.createBookingEnabled || this.configurations.flattenedSettings.wfhBookingAllowed;
          this.homeData.configSubjectData(this.configurations);
          this.getBookings();
          this.updateWidgets();
          let date = new Date();
          date.setMonth(date.getMonth() + 1);
          document.cookie = "timezone=" + this.timezone + ";expires=" + date + ";domain=.moveinsync.com;path=/;secure; SameSite=Strict;";
        },
        err => {
          this.toast.displayMsg("Failed to load required configurations.");
          this.loader.hide();
        }
      );
  }

  private updateWidgets(): void {
    this.widgets = WIDGET_LIST.filter(wdgt => wdgt.reqConfigs.every(cfg => this.configurations.flattenedSettings[cfg]));
    // layout testing
    // this.widgets.push(WIDGET_LIST[0], WIDGET_LIST[1], { ...WIDGET_LIST[2], id: 3 });
    this.updateLayout();
    // this.widgetSvc.refreshWidgets();
  }

  private updateLayout(): void {
    const breakpoints = Object.keys(LayoutSettings.breakpoints);
    this.columnGroups = this.breakpointObs.observe(breakpoints.map(bp => `(max-width: ${bp}px)`)).pipe(
      map(bpState => {
        let { columns } = LayoutSettings;
        if (bpState.matches) {
          columns = LayoutSettings.breakpoints[breakpoints.find(bp => bpState.breakpoints[`(max-width: ${bp}px)`])].columns;
        }
        const cols = this.widgets.reduce((acc, val, idx) => {
          const pos = idx % columns;
          if (acc[pos]) {
            acc[pos].push(val);
          } else {
            acc[pos] = [val];
          }
          return acc;
        }, []);
        return cols;
      })
    );
  }

  private getBookings(filterValue?: boolean): void {
    // this.loader.show();
    const start = parseZone().tz(this.timezone);
    const filter = this.configurations.flattenedSettings?.showBookingFilter ? false : true;
    if (!filterValue && filterValue !== undefined) {
      const check = new AsyncWidget(this.genUpcomingBookingStream(start, filterValue || filter), [minLength(3)]);
      this.allWidgets.removeWidget("bookingSource");
      this.allWidgets.addWidget("bookingSource", check);
    } else if (filterValue) {
      const check = new AsyncWidget(this.genUpcomingBookingStream(start, filterValue || filter), [minLength(3)]);
      this.allWidgets.removeWidget("bookingSource");
      this.allWidgets.addWidget("bookingSource", check);
    } else {
      this.allWidgets = new WidgetGroup({
        heroSource: new AsyncWidget(this.genHeroStream(start, true)),
        bookingSource: new AsyncWidget(this.genUpcomingBookingStream(start, filterValue || filter), [minLength(3)]),
        meetingSource: new AsyncWidget(this.genMeetingStream(start, true)),
        mealSource: new AsyncWidget(this.genMealStream(start, false)),
        calendarSource: new SyncWidget()
      });
    }
    // setTimeout(() => console.log(this.allWidgets.get("bookingSource").state), 5000);
  }

  private listenForBookingUpdates(type: "HERO_BOOKING" | "UPCOMING_BOOKING", data): void {
    if (this.isRedirected) return;
    if (type === "HERO_BOOKING") {
      data = data.getEmployee?.[0]?.bookingDetailDTOS;
    }
    if (!Array.isArray(data)) return;
    const getState = b => (type === "HERO_BOOKING" ? b : b.booking);
    let viewBooking = this.configSvc.viewBookingId && data.find(b => getState(b).bookingRequestId === this.configSvc.viewBookingId);
    viewBooking = viewBooking && typeof viewBooking === "object" && getState(viewBooking);
    let editBooking = this.configSvc.editBookingId && data.find(b => getState(b).bookingRequestId === this.configSvc.editBookingId);
    editBooking = editBooking && typeof editBooking === "object" && getState(editBooking);
    if (viewBooking || editBooking) {
      let type: "VIEW" | "EDIT";
      type = editBooking && viewBooking ? "VIEW" : (editBooking && "EDIT") || "VIEW";
      let bookingHandler;
      (async () => {
        if (type === "VIEW") {
          const bookingHandler = this.handleUpcoming.bind(this, viewBooking);
          return Promise.resolve(bookingHandler);
        } else if (type === "EDIT") {
          const bookingConfig = await this.configSvc.bookingConfigurations.toPromise();
          if (this.configSvc.validateBooking(editBooking, bookingConfig).editBookingAllowed) {
            const bookingHandler = this.handleUpdateBooking.bind(this, editBooking);
            return Promise.resolve(bookingHandler);
          }
        }
      })().then(bookingHandler => {
        if (bookingHandler) {
          bookingHandler.call(this);
        }
      });
      this.router.navigate([], {
        queryParams: {
          [MISC.VIEW_BOOKING_ID]: null,
          [MISC.EDIT_BOOKING_ID]: null
        },
        queryParamsHandling: "merge"
      });
      this.isRedirected = true;
    }
  }

  private genHeroStream(start: Moment, cancelFlag = true): Observable<NsEmpWebExpData.IBookingDetailDTOS | undefined> {
    const end = start.clone().endOf("day");
    return this.apiService
      .getEmpProfile(this.apiService.genEmpDetailQuery(start, end, ["OFFICE", "WFH", "PARKING_TWO", "PARKING_FOUR", "MEALS"], false, cancelFlag))
      .pipe(
        tap(({ data }) => this.listenForBookingUpdates("HERO_BOOKING", data)),
        map(empDetail => {
          if (!empDetail?.dataPresent) {
            this.toast.displayMsg("Unable to load today's booking!");
            return;
          }
          return this.checkForHeroBooking(empDetail?.data?.getEmployee?.[0]?.bookingDetailDTOS);
        })
      );
  }

  checkForHeroBooking(res) {
    const bookingsBase = this.bookingSvc.organiseBookings(res || []);
    const todaysBooking = bookingsBase?.filter(a => this.bookingRequestStatusList.has(a.booking.requestStatus));
    let booking = (todaysBooking?.length > 0 ? todaysBooking[0] : bookingsBase[0])?.booking;
    if (booking?.requestStatus === "SIGNED_OUT" && todaysBooking.length > 1) {
      booking = todaysBooking.find(item => item.booking.requestStatus !== "SIGNED_OUT")?.booking;
    }
    if (!booking) {
      booking = bookingsBase[bookingsBase.map(item => item.booking.requestStatus).lastIndexOf("SIGNED_OUT")]?.booking;
    }
    if (validateHeroBooking(booking, this.timezone)) {
      this.heroBooking = booking;
      return booking;
    }
  }
  getCancellationBooking(res) {
    this.bookingId = this.route.snapshot.queryParamMap.get("bookingId");
    if (this.bookingId) {
      let booking = res.data?.getEmployee?.[0]?.bookingDetailDTOS.find(
        item => item.bookingId === this.bookingId && item.requestStatus != "CANCELLED"
      );
      //No booking found
      if (!booking) {
        this.toast.displayMsg("Booking not found for this user.");
        return;
      }
      //if checkedIn
      if (booking.requestStatus === "SIGNED_IN") return;
      this.bookingSvc.setFormForUpdate(this.configurations, this.employeeData, booking);
      this.modalSvc.show(DeleteConfirmationComponent);
    }
  }
  private genUpcomingBookingStream(start: Moment, cancelFlag?: boolean): Observable<NsEmpWebExpData.IList[]> {
    return this.bookingSvc.profileRules.pipe(
      switchMap(res => {
        const cancelFilter = cancelFlag;
        const end = start
          .clone()
          .add((res.bulkScheduleAllowedDays || this.bookingSvc.interval) + 1, "days")
          .endOf("day");
        this.bookingSvc.setDates(start.valueOf(), end.valueOf());
        return this.apiService
          .getEmpProfile(
            this.apiService.genEmpDetailQuery(
              start.valueOf(),
              end.valueOf(),
              ["OFFICE", "WFH", "PARKING_TWO", "PARKING_FOUR", "MEALS"],
              false,
              cancelFilter
            )
          )
          .pipe(
            map(res => {
              if (res.dataPresent) {
                this.getCancellationBooking(res);
                return res?.data?.getEmployee?.[0]?.bookingDetailDTOS || [];
              } else {
                this.toast.displayMsg(res.errors?.[0]?.message || "Failed to load bookings!", 5000);
                return [];
              }
            })
          );
      }),
      map(res => {
        const bookingsBase = this.bookingSvc.organiseBookings(res || [], this.configurations.flattenedSettings.approvalFlowEnabled);
        const todaysBooking = bookingsBase?.filter(a => this.bookingRequestStatusList.has(a.booking.requestStatus));
        const firstBooking = todaysBooking?.length > 0 ? todaysBooking[0] : bookingsBase[0];
        const todayBookingRequestId =
          validateHeroBooking(firstBooking?.booking, firstBooking?.booking?.timezone) && firstBooking?.booking?.bookingRequestId;
        const bookings = bookingsBase?.filter(
          a =>
            a?.booking?.bookingRequestId !== todayBookingRequestId && a.booking?.bookingRequestId !== this.checkForHeroBooking(res)?.bookingRequestId
        );
        return bookings.filter(b => b?.booking?.bookingRequestId !== this.heroBooking?.bookingRequestId); //.slice(0, 2);
      }),
      tap(res => this.listenForBookingUpdates("UPCOMING_BOOKING", res)),
      filterOut("SIGNED_OUT")
    );
  }

  private genMeetingStream(start: Moment, cancelFlag = true): Observable<NsEmpWebExpData.IList[]> {
    const end = start.clone().endOf("day");
    return this.apiService.getEmpProfile(this.apiService.genEmpDetailQuery(start.valueOf(), end.valueOf(), ["MEETING"], true, cancelFlag)).pipe(
      map(res => {
        if (res.dataPresent) {
          return this.bookingSvc.organiseBookings(res.data?.getEmployee?.[0]?.bookingDetailDTOS || []);
        } else {
          this.toast.displayMsg(res.errors?.[0]?.message || "Failed to load meetings!", 5000);
          return [];
        }
      }),
      filterOut("SIGNED_OUT")
    );
  }

  private genMealStream(end: Moment, cancelFlag = false): Observable<NsEmpWebExpData.IList[]> {
    const start = end
    .clone()
    .subtract(3, "days")
    .startOf("day");
    return this.apiService.getEmpProfile(this.apiService.genEmpDetailQuery(start.valueOf(), end.valueOf(), ["OFFICE","WFH","PARKING_TWO","PARKING_FOUR","MEALS"], false, cancelFlag)).pipe(
      map(res => {
        if (res.dataPresent) {
          return this.bookingSvc.organiseBookings(res.data?.getEmployee?.[0]?.bookingDetailDTOS || []);
        } else {
          this.toast.displayMsg(res.errors?.[0]?.message || "Failed to load meals!", 5000);
          return [];
        }
      }),
      filterOut("CANCELLED")
    );
  }

  setPreferences(): void {
    this.apiService.getEmpPreferences().subscribe(preferences => (this.bookingSvc.preferences = preferences));
  }

  handleUpcoming(booking: NsEmpWebExpData.IBookingDetailDTOS): void {
    this.bookingSvc.setFormForUpdate(this.configurations, this.employeeData, booking);
    const upcomingRef = this.drawerSvc.show(UpcomingBookingsComponent, { booking, configs: this.configurations });
    upcomingRef.afterClosed.subscribe(res => {
      if (res) {
        this.handleUpdateBooking(res);
      }
    });
  }

  handleMeetings(booking: NsEmpWebExpData.IBookingDetailDTOS) {
    this.router.navigate(["/" + this.user.environment.navLinks.meetingRooms], {
      queryParams: { viewMeetingId: booking.meetingId },
      queryParamsHandling: "merge"
    });
  }

  handleUpdateBooking(booking: NsEmpWebExpData.IBookingDetailDTOS): void {
    const config = this.bookingSvc.setFormForUpdate(this.configurations, this.employeeData, booking);
    const ref = this.drawerSvc.show(BookingComponent, config);
    ref.afterClosed.subscribe(res => {
      if (res === "DONE") {
        this.widgetSvc.refreshWidgets("BOOKINGS");
      }
    });
  }

  handleCardAction({ type, booking }: { type: NsEmpWebExpData.TCardActions; booking?: NsEmpWebExpData.IBookingDetailDTOS }): void {
    this.analytics.send("emp_web_today_bookings", "emp_web", "click", type);
    if (type === "Edit") {
      this.handleUpdateBooking(booking);
    } else if (type === "Cancel") {
      this.bookingSvc.setFormForUpdate(this.configurations, this.employeeData, booking);
      this.modalSvc.show(DeleteConfirmationComponent);
    } else if (type === "View") {
      this.handleUpcoming(booking);
    } else if (type === "Convert") {
      this.handleUpdateBooking({
        ...booking,
        bookingRequestType: booking.bookingRequestType === "OFFICE" ? "WFH" : "OFFICE"
      });
    }
  }

  handleCheckout(booking: NsEmpWebExpData.IBookingDetailDTOS): void {
    if (booking.bookingRequestType === "OFFICE") {
      this.officeCheckout(booking);
    } else if (booking.bookingRequestType === "WFH") {
      this.homeCheckout(booking);
    }
  }

  officeCheckout(booking: NsEmpWebExpData.IBookingDetailDTOS): void {
    this.loader.show();
    const now = parseZone().tz(this.timezone).valueOf();
    this.bookingSvc.offices
      .pipe(
        switchMap(offices => {
          const ofc = offices.find(o => o.guid === booking.officeId);
          return this.apiService.wfoUpdate({
            action: "SIGNED_OUT",
            bookingId: booking.bookingId,
            buId: this.user.employeeInfo.buid,
            empGuid: this.employeeData.empGuid,
            empId: this.employeeData.empId,
            isEntryAllowed: true,
            isScanSuccess: true,
            officeName: ofc?.address,
            requestId: booking.bookingRequestId,
            scanTime: String(now),
            scanType: "EMPLOYEE_WEB"
          });
        })
      )
      .subscribe(
        res => {
          this.loader.hide();
          if (res?.errorCode === 500) {
            this.toast.displayMsg(res.message);
            return;
          }
          this.toast.displayMsg("Checkout successful.");
          this.widgetSvc.refreshWidgets("HERO");
          this.widgetSvc.setWidgetAction("CHECK-OUT");
        },
        () => {
          this.loader.hide();
          this.toast.displayMsg("Something went wrong. Please try again after sometime.");
        }
      );
  }

  homeCheckout(booking: NsEmpWebExpData.IBookingDetailDTOS): void {
    this.loader.show();
    const now = parseZone().tz(this.timezone).valueOf();
    this.apiService
      .wfhUpdate(booking.bookingRequestId, {
        clockInTime: now,
        timestamp: now,
        type: "CLOCK_OUT"
      })
      .subscribe(res => {
        this.loader.hide();
        this.toast.displayMsg("Checkout successful.");
        this.widgetSvc.refreshWidgets("HERO");
        this.widgetSvc.setWidgetAction("CHECK-OUT");
      });
  }

  showCheckinConfirmPopup(bookingData: NsEmpWebExpData.IBookingDetailDTOS): void {
    const url = this.configurations.BUSettings.features.find(r => r.id === "communicationRegistry");
    const conf = this.configurations.BUSettings.features.find(r => r.id === "booking");
    const { IPBasedCheckinEnabled } = this.configurations.flattenedSettings;
    this.modalSvc.show(CheckinConfirmComponent, {
      config: { ...url, ...conf, IPBasedCheckinEnabled },
      booking: bookingData,
      employeeData: this.employeeData
    });
  }

  handleMeals(event: NsEmpWebExpData.IMealFeedbackModalInfo){
    const ref = this.modalSvc.show(MealFeedbackModalComponent, event);
    ref.afterClosed.subscribe((res)=>{
        this.allWidgets.get("mealSource").reset();
    })
  }

  handleWidgetAction(widget: NsEmpWebExpData.IWidget, id: number) {
    if (widget?.id === 4 && id === 1) {
      this.router.navigate(["/" + this.user.environment.navLinks.meetingRooms], {
        queryParamsHandling: "preserve"
      });
    }
    else if(widget?.id === 3 && id === 1){
      this.router.navigate(["/" + this.user.environment.navLinks.bookingHistory], {
        queryParamsHandling: "preserve"
      });
    }
  }

  openTeamCalendar(val): void {
    this.analytics.send("emp_web_team_calendar", "emp_web", "click", `${this.user.employeeInfo.buid}/${this.user.employeeInfo.empGuid}`);
    this.showTeamCalendar.emit();
  }
}
